import React, { useState, useEffect, useContext } from "react";

import { Alert } from "@material-ui/lab";
import AccountCircleIcon from "mdi-react/AccountCircleIcon";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import {
  CircularProgress,
  Card,
  CardContent,
  Typography,
  Divider,
  Snackbar,
} from "@material-ui/core";

import color from "../../../utils/color";
import UserEditModal from "./modals/UserEditModal";
import PrimaryButton from "../../Common/primary_button";
import ChangePasswordModal from "./modals/ChangePasswordModal";
import LanguageSettingModal from "./modals/LanguageSettingModal";
import { getUserInfo, auth } from "../../../controllers/snowm_firebase";
import { LocalizationContext } from "../../../contexts/localization_context";
import {
  FormContainer,
  Row,
  Col,
  StyledTypography,
} from "../../../styles/snowm_styled";

const UserProfile = () => {
  const [loading, setLoading] = useState(true);
  const [userProfile, setUserProfile] = useState({});
  const [openLocationModal, setOpenLocationModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openChangePwdModal, setOpenChangePwdModal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const { strings } = useContext(LocalizationContext);
  const {
    sidemenu: { USER_PROFILE },
    inputLabel: { NAME, EMAIL, ADDRESS, CONTACT_NUMBER, DESIGNATION },
    misc: { LANGUAGE_SETTINGS, CHANGE_PASSWORD },
    action: { EDIT },
  } = strings;

  useEffect(() => {
    let unsubscribe = true;
    const updateUser = (response) => {
      if (unsubscribe) {
        setUserProfile(response);
        setLoading(false);
      }
    };
    getUserInfo(auth().currentUser.uid, updateUser);
    return () => {
      unsubscribe = false;
    };
  }, []);

  const handleLanguageSettingClick = () => {
    setOpenLocationModal(true);
  };

  const handleClose = () => {
    setOpenLocationModal(false);
  };

  const handleLanguage = () => {
    // TODO: set the language of the site
    setOpenLocationModal(false);
  };

  const handleEditButton = () => {
    setOpenEditModal(false);
  };
  const handleEditIcon = () => {
    setOpenEditModal(true);
  };

  const handleEditCloseButton = () => {
    setOpenEditModal(false);
  };

  function handleChangePwdButton() {
    setOpenChangePwdModal(true);
  }

  function handleSnackbar() {
    setOpenSnackbar(!openSnackbar);
    setOpenChangePwdModal(false);
  }

  function handleChangePwdModalClose() {
    setOpenChangePwdModal(false);
  }

  if (!loading) {
    return (
      <>
        <FormContainer>
          <Card style={{ margin: "2rem", borderRadius: "10px" }}>
            <CardContent style={{ padding: "3em 3em 0" }}>
              <Row
                width="auto"
                justify="space-between"
                style={{ padding: "0 2em" }}
              >
                <Col style={{ flexGrow: 1, alignItems: "center" }}>
                  <Typography style={{ fontWeight: 700 }}>
                    {USER_PROFILE}
                  </Typography>
                  {userProfile.imageUrl ? (
                    <img
                      height={120}
                      width={120}
                      style={{ borderRadius: "100%" }}
                      alt="Profile pic"
                      src={userProfile.imageUrl}
                      onError={(e) => {
                        e.target.src =
                          "data:image/jpeg;base64,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";
                      }}
                    />
                  ) : (
                    <div>
                      <AccountCircleIcon
                        size={190}
                        color={color.boxShadowColor}
                      />
                    </div>
                  )}
                </Col>
                <Col style={{ flexGrow: 1 }}>
                  <Row justify="space-between">
                    <StyledTypography>{NAME}</StyledTypography>
                    <StyledTypography
                      weightoffont="700"
                      textcolor={color.detailColor}
                    >
                      {userProfile.name}
                    </StyledTypography>
                  </Row>
                  <Row justify="space-between">
                    <StyledTypography>{EMAIL}</StyledTypography>
                    <StyledTypography
                      weightoffont="700"
                      textcolor={color.detailColor}
                    >
                      {userProfile.email}
                    </StyledTypography>
                  </Row>
                  <Row justify="space-between">
                    <StyledTypography>{ADDRESS}</StyledTypography>
                    <StyledTypography
                      weightoffont="700"
                      textcolor={color.detailColor}
                    >
                      {userProfile.address}
                    </StyledTypography>
                  </Row>
                  <Row justify="space-between">
                    <StyledTypography>{CONTACT_NUMBER}</StyledTypography>
                    <StyledTypography
                      weightoffont="700"
                      textcolor={color.detailColor}
                    >
                      {userProfile.phoneNumber}
                    </StyledTypography>
                  </Row>
                  <Row justify="space-between">
                    <StyledTypography>{DESIGNATION}</StyledTypography>
                    <StyledTypography
                      weightoffont="700"
                      textcolor={color.detailColor}
                    >
                      {userProfile.designation}
                    </StyledTypography>
                  </Row>
                  <Row justify="flex-end">
                    <PrimaryButton onClick={handleEditIcon}>
                      {EDIT}
                    </PrimaryButton>
                  </Row>
                  <Row justify="flex-end">
                    <PrimaryButton onClick={handleChangePwdButton}>
                      {CHANGE_PASSWORD}
                    </PrimaryButton>
                  </Row>
                </Col>
              </Row>
              <Divider />
              <Row
                style={{
                  padding: "1em 0 1em 1em",
                  color: color.snomwBlue,
                  cursor: "pointer",
                }}
                onClick={() => handleLanguageSettingClick()}
              >
                <Typography style={{ fontWeight: 700 }}>
                  {LANGUAGE_SETTINGS}
                </Typography>
                <ArrowForwardIosIcon style={{ marginLeft: 6 }} />
              </Row>
            </CardContent>
          </Card>
        </FormContainer>
        <LanguageSettingModal
          onConfirm={(language) => handleLanguage(language)}
          open={openLocationModal}
          onClose={handleClose}
        />
        <UserEditModal
          openModal={openEditModal}
          userProfileData={userProfile}
          handleCancelButton={handleEditCloseButton}
          handleEditButton={handleEditButton}
        />
        <ChangePasswordModal
          open={openChangePwdModal}
          handleSnackbar={handleSnackbar}
          onClose={handleChangePwdModalClose}
        />
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={openSnackbar}
          autoHideDuration={5000}
          onClose={handleSnackbar}
        >
          <Alert onClose={handleSnackbar} severity="info">
            Password changed successfully.
          </Alert>
        </Snackbar>
      </>
    );
  }
  return (
    <div style={{ margin: "35% 50%" }}>
      <CircularProgress />
    </div>
  );
};

export default UserProfile;
